export const spacings = {
  xs: '2px',
  sm: '5px',
  md: '10px',
  lg: '20px',
  xl: '24px',
  xxl: '30px'
};

export const borders = {
  radius: {
    sm: '2px',
    md: '5px',
    lg: '10px'
  }
};

export const fontWeights = {
  thin: '200',
  normal: '400',
  bold: '600',
  extraBold: '800'
};
